// src/lib/useFormFunnel.js
// Funnel-events per formulier: form_start (eerste focus), form_error (veldnaam bij
// mislukte validatie) en form_abandon (pagehide na start zonder verzenden).
// Geen PII: alleen formuliernaam en veldnaam.
import { useCallback, useEffect, useRef } from 'react';
import { trackEvent } from './analytics';

export function useFormFunnel(form) {
  const started = useRef(false);
  const done = useRef(false);
  const node = useRef(null);
  const listener = useRef(null);

  const onFocus = useCallback(() => {
    if (started.current) return;
    started.current = true;
    trackEvent('form_start', { form });
  }, [form]);

  const error = useCallback((field) => {
    trackEvent('form_error', { form, field: field || 'unknown' });
  }, [form]);

  const submitted = useCallback(() => { done.current = true; }, []);

  useEffect(() => {
    const onHide = () => {
      if (started.current && !done.current) {
        done.current = true; // één keer
        trackEvent('form_abandon', { form });
      }
    };
    window.addEventListener('pagehide', onHide);
    return () => window.removeEventListener('pagehide', onHide);
  }, [form]);

  // Native browservalidatie (required / type=email) blokkeert submit vóór onSubmit; het
  // 'invalid'-event bubbelt niet, dus luister in de capture-fase op het formulier.
  const formRef = useCallback((el) => {
    if (node.current && listener.current) node.current.removeEventListener('invalid', listener.current, true);
    node.current = el;
    listener.current = null;
    if (el) {
      listener.current = (e) => error(e.target && (e.target.name || e.target.id));
      el.addEventListener('invalid', listener.current, true);
    }
  }, [error]);

  return { formRef, onFocus, error, submitted };
}
